import * as tslib_1 from "tslib";
import { ElementRef, EventEmitter, OnChanges, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ActivatedRoute, Router } from '@angular/router';
import { MaintenancesApi } from '@core/api/maintenances/maintenances.api';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { environment } from '@environment';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { merge } from 'rxjs';
import { debounceTime, map, startWith, switchMap, tap } from 'rxjs/operators';
import validator from 'validator';
import { DialogEditMaintenanceComponent } from '../../dialogs/dialog-edit-maintenance/dialog-maintenances.component';
import { MaintenanceFilterState } from '../../filter/services/maintenance-filter-state.service';
var DatatableMaintenancesComponent = /** @class */ (function () {
    function DatatableMaintenancesComponent(matDialog, route, router, maintenancesApi, authenticationService, fuseProgressBarService, filterMaintenancesService) {
        this.matDialog = matDialog;
        this.route = route;
        this.router = router;
        this.maintenancesApi = maintenancesApi;
        this.authenticationService = authenticationService;
        this.fuseProgressBarService = fuseProgressBarService;
        this.filterMaintenancesService = filterMaintenancesService;
        this.updatedValues = new EventEmitter();
        this.dataSource = [];
        this.isLoadingResults = true;
        this.resultsLength = 0;
        this.tabsToOpen = {
            general: 0,
            pendencies: 1,
            tasks: 2,
            forms: 3,
            quotations: 4,
            deadlines: 5,
            products: 6,
            services: 7,
            comments: 8,
            attachments: 9,
            logs: 10
        };
        this.hasLabelViewPermission = this.authenticationService.hasPermission('labels-list');
        this.displayedColumns = this.columns;
    }
    DatatableMaintenancesComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.sort.active = 'openedAt';
        this.sort.direction = 'desc';
        merge(this.reload, this.paginator.page, this.sort.sortChange.pipe(tap(function () { return _this.paginator.firstPage(); })), this.filterMaintenancesService.onChangeFilter.pipe(tap(function () { return _this.paginator.firstPage(); })))
            .pipe(startWith({}), debounceTime(500), switchMap(function () {
            _this.isLoadingResults = true;
            _this.fuseProgressBarService.show();
            return _this.searchMaintenances(_this.filterMaintenancesService.query);
        }), map(function (data) {
            _this.resultsLength = data.totalCount;
            return data.items;
        }))
            .subscribe(function (data) {
            _this.datatable.nativeElement.scrollTo({
                top: 0,
            });
            _this.isLoadingResults = false;
            _this.fuseProgressBarService.hide();
            _this.updatedValues.emit(_this.resultsLength);
            _this.dataSource = data;
        });
        this.openEditDialogOnInit();
    };
    DatatableMaintenancesComponent.prototype.ngOnChanges = function () {
        this.displayedColumns = this.columns;
    };
    DatatableMaintenancesComponent.prototype.openEditDialogOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var maintenanceId, selectedTab;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        maintenanceId = this.route.snapshot.queryParamMap.get('id');
                        selectedTab = this.route.snapshot.queryParamMap.get('selectedTab');
                        if (!(maintenanceId && validator.isUUID(maintenanceId))) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.editDialog({ id: maintenanceId }, !this.hasEditMaintenancePermission, this.tabsToOpen[selectedTab])];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    DatatableMaintenancesComponent.prototype.editDialog = function (maintenance, isViewMode, selectedTabIndex) {
        if (selectedTabIndex === void 0) { selectedTabIndex = 0; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var editMaintenanceDialog;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.fuseProgressBarService.show();
                        return [4 /*yield*/, this.maintenancesApi.searchOne(maintenance.id).toPromise()];
                    case 1:
                        maintenance = _a.sent();
                        this.fuseProgressBarService.hide();
                        editMaintenanceDialog = this.matDialog.open(DialogEditMaintenanceComponent, {
                            panelClass: 'dialog-edit-maintenance',
                            data: {
                                maintenance: maintenance,
                                isViewMode: isViewMode,
                                selectedTabIndex: selectedTabIndex
                            }
                        });
                        editMaintenanceDialog.afterClosed()
                            .toPromise()
                            .then(function (reload) {
                            if (reload) {
                                _this.reload.next(reload);
                            }
                        });
                        editMaintenanceDialog.componentInstance.isLoading.subscribe(function (reload) {
                            _this.reload.next(reload);
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    DatatableMaintenancesComponent.prototype.searchMaintenances = function (query) {
        var options = {
            orderColumn: this.sort.active,
            order: this.sort.direction,
            offset: this.paginator.pageIndex * this.paginator.pageSize,
            limit: this.paginator.pageSize
        };
        return this.maintenancesApi.searchWithWarranties(query, options);
    };
    DatatableMaintenancesComponent.prototype.copyToClipboard = function (value) {
        navigator.clipboard.writeText(value);
    };
    DatatableMaintenancesComponent.prototype.getPendencyTitles = function (pendencies) {
        return pendencies.map(function (pendency) { return pendency.title; });
    };
    DatatableMaintenancesComponent.prototype.redirectToPaymentsPage = function (paymentId) {
        window.location.href = environment.MOUNTDOOM_2_URL + "/#/pagamentos?id=" + paymentId;
    };
    return DatatableMaintenancesComponent;
}());
export { DatatableMaintenancesComponent };
